// extracted by mini-css-extract-plugin
module.exports = {"privacy-page":"styles_privacy-page__2xIy6","privacy-page-body":"styles_privacy-page-body__2-K9J","last-modified":"styles_last-modified__1oLnx"};